import React from "react";
import SearchInput from "../SearchInupt";
import SmallNavTabs from "../navTabs/SmallNavTabs";
import CapButton from "../../common/buttons/CapButton";
import {isAdminAsPartner, isPartner} from "../../../utils/authUtils";

export default function ContentHeader({
                                          tabs,
                                          selectedTabName,
                                          onSelectTab,
                                          containerRef,
                                          width,
                                          navRightButtons,
                                          displaySearchInput,
                                          contentHeaderButtons,
                                          onChangeSearchInput,
                                          searchInputValue,
                                          searchInputAmount,
                                          beforeSearchInputAmount,
                                          searchInputLabel,
                                      }) {
    const displayBlockFilters = contentHeaderButtons || displaySearchInput;
    const isPartnerPage = isAdminAsPartner() || isPartner();


    return (
        <div
            className="card-header content-header open-menu"
            id="contentHeader"
            key={selectedTabName}
            ref={containerRef}
            style={{width: width + "px"}}
        >
            {navRightButtons}
            <SmallNavTabs tabs={tabs} selectedTabName={selectedTabName} onSelectTab={onSelectTab} />

            {displayBlockFilters && (
                <div className="block-filters">
                    {isPartnerPage && (
                        <CapButton />
                    )}
                    {displaySearchInput && (
                        <SearchInput
                            amount={searchInputAmount}
                            allAmount={beforeSearchInputAmount}
                            label={searchInputLabel}
                            onTextTyping={onChangeSearchInput}
                            searchValue={searchInputValue}
                        />
                    )}
                    <div>{contentHeaderButtons}</div>

                </div>
            )}
        </div>
    );
}
